import TransitApi from './base'

export default {
  // TODO: Add search, filters and sort params
  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/distributor/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/distributor/details/${params.id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getUsers(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/distributor/${params.id}/users`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async addAdditionalUser(distributorId, params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(
        `/distributor/${distributorId}/additional-user`,
        params
      )
      return result
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id
        ? `/distributor/details/${params.id}`
        : '/distributor/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/distributor/${params.id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
